import React, { useEffect, useState, useContext } from "react";
import { IoIosArrowDown } from "react-icons/io";
import { Toaster, toast } from "react-hot-toast";
import { GlobalContext } from "../../../../Context/GlobalContext";

export default function NewCustomAttributeModal({ onClose }) {
  // const {  api, adminId } = useContext(GlobalContext); 

  const [name, setName] = useState("");
  const [keyVal, setKeyVal] = useState("");
  const [formatOpen, setFormatOpen] = useState(false);
  const [format, setFormat] = useState("");

  const formats = [
    "Short Text (Max 250 characters)",
    "Number",
    "Decimal Number",
    "True or False",
    "Date",
    "Long Text (Max 2048 characters)",
    "List (Single Selection)",
    "List (Multi Selection)",
    "Event",
  ];

  useEffect(() => {
    // if you keep a shared context, update it here
    // setNewCustomAttributeDetails({ name, key: keyVal, format });
  }, [name, keyVal, format]);

  const create = () => {
    if (!name || !format) {
      toast.error("Please fill in the required fields!");
      return;
    }
    toast.success("Attribute created successfully!");
    setName("");
    setKeyVal("");
    setFormat("");
    onClose?.();
  };

  return (
    <div className="space-y-3">
      <Toaster position="top-right" />
      <div>
        <div className="mb-1 text-xs text-gray-500">Name</div>
        <input
          className="h-10 w-full rounded-xl border px-3 text-sm outline-none"
          placeholder="Enter custom attribute label"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>

      <div>
        <div className="mb-1 text-xs text-gray-500">Key (Optional)</div>
        <input
          className="h-10 w-full rounded-xl border px-3 text-sm outline-none"
          placeholder="Enter custom attribute key"
          value={keyVal}
          onChange={(e) => setKeyVal(e.target.value)}
        />
      </div>

      <div className="relative">
        <div className="mb-1 text-xs text-gray-500">Format</div>
        <button
          className="flex h-10 w-full items-center justify-between rounded-xl border px-3 text-sm"
          onClick={() => setFormatOpen((o) => !o)}
        >
          <span>{format || "Select format"}</span>
          <IoIosArrowDown />
        </button>
        {formatOpen && (
          <div className="absolute z-10 mt-2 w-full rounded-xl border bg-white p-1 shadow-lg">
            {formats.map((f) => (
              <button
                key={f}
                className="block w-full rounded-lg px-3 py-2 text-left text-sm hover:bg-gray-50"
                onClick={() => {
                  setFormat(f);
                  setFormatOpen(false);
                }}
              >
                {f}
              </button>
            ))}
          </div>
        )}
      </div>

      <div className="flex justify-end gap-2 border-t pt-3">
        <button className="h-9 rounded-xl border px-3 text-sm" onClick={onClose}>
          Cancel
        </button>
        <button className="h-9 rounded-xl bg-[#01C37D] px-4 text-sm font-medium text-white" onClick={create}>
          Create
        </button>
      </div>
    </div>
  );
}
